import React from 'react';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

type BackdropProps = {
  open: boolean;
  children?: React.ReactNode;
};

export function LoadingComponent({ open, children }: BackdropProps) {
  return (
    <Backdrop
      sx={(theme) => ({ color: '#076596', zIndex: theme.zIndex.drawer + 1 })}
      open={open}
    >
      {children ?? <CircularProgress color="inherit" size={100} />}
    </Backdrop>
  );
}
